import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingCart, X, Star } from "lucide-react";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/css/customer/customerPannel/wishlist/Wishlist.css";

const Wishlist = () => {

  const { baseUrl, authToken ,baseUrlForFile, loggedInCustomer} = useContext(AppContext);

  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState(null);

  // ── View Wishlist ─────────────────────────────────────
  const viewWishlist = () => {
   
    setLoading(true);
    axios.get(`${baseUrl}/customer/wishlist/viewWishlist`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
    .then((response) => {
      console.log(response.data);
      setWishlistItems(response.data.wishlistItems);
      setLoading(false);
    })
    .catch((error) => {
      console.log(error);
      setError("Failed to load wishlist");
      setLoading(false);
    });
  };

  useEffect(() => {
    viewWishlist();
  }, []);

  // ── Remove from Wishlist ──────────────────────────────
  const handleRemove = (id) => {
    console.log(id);
    const formdata = new FormData();
    formdata.append("id", id);
    formdata.append("adcustomer_id", loggedInCustomer.id);

    axios.post(`${baseUrl}/customer/wishlist/removeFromWishlist`,formdata, {
      headers: { Authorization: `Bearer ${authToken}` },
      
    })
    .then((response) => {
      console.log(response.data);
      if (response.data.success) {
        viewWishlist();
      }
    })
    .catch((error) => {
      console.log(error);
    });
  };

  // ── Create Cart--
  const handleAddToCart = (item) => {
    if (!item.product) return;

    axios.post(`${baseUrl}/customer/cart/createCartItem`, {
      // adcustomer_id,
      adproduct_id: item.product.id,
      quantity:     1,
      price:        item.product.price,
    })
    .then((response) => {
      console.log("Cart created:", response.data);
    })
    .catch((error) => {
      console.log("createCart Error:", error);
    });
  };

  if (loading) {
    return (
      <div className="wl-page">
        <p style={{ textAlign: "center", marginTop: "50px" }}>Loading wishlist...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="wl-page">
        <p style={{ textAlign: "center", color: "red", marginTop: "50px" }}>{error}</p>
      </div>
    );
  }

  return (
    <div className="wl-page">
      <div className="wl-header">
        <div>
          <h1 className="wl-title">My Wishlist</h1>
          <p className="wl-subtitle">Your saved furniture items</p>
        </div>
        <div className="wl-count-badge">
          <span className="wl-count-num">{wishlistItems?.length}</span>
          <span className="wl-count-lbl">Items</span>
        </div>
      </div>

      {wishlistItems?.length === 0 ? (
        <div className="wl-empty">
          <Heart size={44} strokeWidth={1.2} color="#D67E43" style={{ opacity: 0.45 }} />
          <h3>Your Wishlist is Empty</h3>
          <p>Save your favorite furniture items to buy them later</p>
          <Link to="/products" className="wl-browse-btn">Browse Furniture</Link>
        </div>
      ) : (
        <>
          <div className="wl-grid">
            {wishlistItems?.map((item) => (
              <div key={item.id} className="wl-card">

                <button
                  className="wl-remove-btn"
                  onClick={() => handleRemove(item.id)}
                  aria-label="Remove"
                >
                  <X size={14} strokeWidth={2.5} />
                </button>

                <div className="wl-img-wrap">
                  <img src={`${baseUrlForFile}/${item.adproduct?.productimages?.[0].image_path}`} alt={item.adproduct?.name} />
                </div>

                <div className="wl-info">
                  <h3 className="wl-name">{item.adproduct?.name}</h3>

                  <div className="wl-rating">
                    <div className="wl-stars">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          size={12}
                          strokeWidth={1.5}
                          fill={i < Math.floor(item.adproduct?.rating || 0) ? "#f59e0b" : "none"}
                          color={i < Math.floor(item.adproduct?.rating || 0) ? "#f59e0b" : "#d1d5db"}
                        />
                      ))}
                    </div>
                    <span className="wl-rating-txt">
                      {item.adproduct?.rating} ({item.adproduct?.reviews})
                    </span>
                  </div>

                  <div className="wl-price-row">
                    <span className="wl-price-current">
                      Rs. {item.adproduct?.price?.toLocaleString()}
                    </span>
                  </div>

                  <button
                    className="wl-cart-btn"
                    onClick={() => handleAddToCart(item)}
                  >
                    <ShoppingCart size={15} strokeWidth={2} />
                    Add to Cart
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="wl-continue">
            <Link to="/products" className="wl-continue-btn">Continue Shopping →</Link>
          </div>
        </>
      )}
    </div>
  );
};

export default Wishlist;